export enum PriorityType {
  None,
  Low,
  Medium,
  High,
  Emergency,
}
